import { ScrollView } from 'devextreme-react'
import React, { useState } from 'react'
import { ICSModal } from '../ICSModal/ICSModal'
import { ModalBody } from 'reactstrap'

export const ICSDataCellDetailView = props => {
  const [hidden, setHidden] = useState<boolean>(false)
  const toggle = () => {
    setHidden(hidden ? false : true)
  }

  const extendedDisplay = (
    <>
      <ICSModal
        visible={hidden}
        onHiding={toggle}
        dragEnabled={false}
        closeOnOutsideClick={true}
        defaultWidth={props.modalWidth}
        defaultHeight={props.modalHeight}
      >
          <ModalBody>
          {props.value}
          </ModalBody>
      </ICSModal>
    </>
  )

  return (
    <>
      {extendedDisplay}
      <span onClick={toggle} style={{ cursor: 'pointer' }}>
        {props.value}
      </span>
    </>
  )
}

ICSDataCellDetailView.defaultProps = {
  modalWidth: '20vw',
  modalHeight: '15vh',
}
